import { render, staticRenderFns } from "./family-number.vue?vue&type=template&id=11f3de75&scoped=true&"
import script from "./family-number.vue?vue&type=script&lang=js&"
export * from "./family-number.vue?vue&type=script&lang=js&"
import style0 from "./family-number.vue?vue&type=style&index=0&id=11f3de75&lang=scss&scoped=true&"
import style1 from "./family-number.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f3de75",
  null
  
)

export default component.exports